const shaka = require("shaka-player/dist/shaka-player.ui")
export default class CaptionButton extends shaka.ui.Element {
  constructor(parent: any, controls: any, player: any) {
    super(parent, controls)
    // The actual button that will be displayed
    this.button_ = document.createElement("button")
    player.setTextTrackVisibility(false)
    this.button_.classList.add("shaka-caption-button")
    this.button_.classList.add("material-icons")
    this.button_.classList.add("shaka-caption-off")
    this.button_.setAttribute("aria-label", "activate captions")
    this.button_.textContent = "closed_caption"
    this.parent.appendChild(this.button_)
    // Listen for clicks on the button to start captions
    this.eventManager.listen(this.button_, "click", () => {
      player.setTextTrackVisibility(!player.isTextTrackVisible())
      var attrs = this.button_.getAttribute("class")
      attrs = attrs.replace("shaka-caption-off", "")
      attrs = attrs.replace("shaka-caption-on", "")
      if (player.isTextTrackVisible()) {
        attrs += "shaka-caption-on"
        this.button_.setAttribute("aria-label", "deactivate captions")
      } else {
        attrs += "shaka-caption-off"
        this.button_.setAttribute("aria-label", "activate captions")
      }
      this.button_.setAttribute("class", attrs)
    })
  }
}
